import dayjs from '../../config/dayjs';
import { useDayjsLocale } from '../../services/dayjs-locale-context';

export const useGetLocalizedDate = () => {
  const { locale: dayjsLocale } = useDayjsLocale();

  const getLocalizedDate = (date: Date, locale?: string): string => {
    return dayjs(date)
      .locale(locale ?? dayjsLocale)
      .format('L');
  };

  return { getLocalizedDate };
};
